import momentCN from 'moment/locale/zh-cn'
import login from './zh-CN/login'

const components = {
  momentName: 'zh-cn',
  momentLocale: momentCN
}

export default {
  'message': '-',

  ...components,
  ...login
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN.js